export enum colors {
	primary = 'primary',
	danger = 'danger',
	navy = 'navy',
}

export const allColors = ['#1ab394', '#ed5565', '#3d4d5d'];
